export default __webpack_public_path__ + "static/media/logo.772ec63d.png";